import { isTheDropCoupon } from '@exp/components/products/theDropUtils';

import { PRIZE_STATUS } from '../../js/common/constants';
import { type RootState } from '../../redux/store';

export const buildAnalyticsData = (state: RootState) => {
  const {
    singleCheckout: {
      cartSetKey,
      checkoutData,
      couponFromCart,
      fflRequired,
      isGhosting,
      shipments,
      totalItemQuantity,
    },
  } = state;

  return {
    availableCouponCount: checkoutData?.coupons?.length,
    availableRewardCount: checkoutData?.prizes?.filter(({ status }) => status === PRIZE_STATUS.AVAILABLE).length,
    brandCount: checkoutData?.brands?.length,
    costs: checkoutData?.costs,
    couponFromCart,
    fflRequired,
    groupKey: cartSetKey,
    // @ts-expect-error proptypes / ts mismatch
    hasTheDrop: checkoutData?.coupons?.some(isTheDropCoupon),
    isGhosting,
    paymentOptions: Object.values(checkoutData?.paymentOptions || {}).map((option) => option.paymentTypes).flat(),
    paymentRequired: checkoutData?.paymentRequired,
    shipmentCosts: checkoutData?.brands?.map((brand) => brand.shipments?.map((brandShipment) => ({
      ...brandShipment.costs || {},
      orgId: brand.orgId,
      orgName: brand.orgName,
      productCodes: brandShipment.items?.map((item) => item.productCode),
      skus: brandShipment.items?.map((item) => item.sku),
      storeId: brandShipment.storeIds?.[0],
      storeIds: brandShipment.storeIds,
    }))),
    shipmentCount: shipments?.length,
    totalItemQuantity,
  };
};

export default buildAnalyticsData;
